import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Card } from '../../../../../../shared/page-info';

@Component({
    selector: 'app-product-option',
    templateUrl: './product-option.component.html',
    styleUrls: ['./product-option.component.scss'],
    standalone: false
})
export class ProductOptionComponent implements OnInit {
  @Input() card: Card;
  cardInfo: string;
  cardType: string;
  cardTitle: string;
  cardButton: string;
  cardFormType: string;
  cardQuestion: string;
  cardFirstReason: string;
  cardSecondReason: string;
  cardFirstReasonImgAlt: string;
  cardFirstReasonImgSrc: string;
  cardSecondReasonImgAlt: string;
  cardSecondReasonImgSrc: string;

  ngOnInit(): void {
    this.cardInfo = this.card?.info;
    this.cardTitle = this.card?.title;
    this.cardType = this.card?.route_to;
    this.cardFormType = this.card?.type;
    this.cardQuestion = this.card?.question;
    this.cardButton = this.card?.button_text;
    this.cardFirstReason = this.card?.first_reason;
    this.cardSecondReason = this.card?.second_reason;
    this.cardFirstReasonImgAlt = this.card?.first_reason_icon_alt;
    this.cardSecondReasonImgAlt = this.card?.second_reason_icon_alt;
    this.cardFirstReasonImgSrc = `/assets/images/${this.card?.first_reason_icon}`;
    this.cardSecondReasonImgSrc = `/assets/images/${this.card?.second_reason_icon}`;
  }

  redirectForm(): void {
    let params = new HttpParams();
    if (this.cardType) {
      params = params.set('LoanPurpose', this.cardType);
    }
    if (this.cardFormType) {
      params = params.set('FormType', this.cardFormType);
    }
    document.location.href = '/communication/rates-form?' + params.toString();
  }
}
